var _defs, _text, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup192(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.403,
    height: 27.208,
    viewBox: "0 0 84.403 27.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{font-size:7px;font-family:Rockwell-BoldItalic, Rockwell;font-weight:700;font-style:italic;letter-spacing:0.097em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(43.403 25.208)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REWARDS"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.776,324.88l2.531.838a7.093,7.093,0,0,1-1.218,1.408,7.77,7.77,0,0,1-1.5,1.085,6.569,6.569,0,0,1-1.732.685,6.951,6.951,0,0,1-1.9.248,7.59,7.59,0,0,1-5.367-12.979,7.2,7.2,0,0,1,5.367-2.246,7.451,7.451,0,0,1,2.969.59,7.9,7.9,0,0,1,2.436,1.656l-1.827,1.789a5.053,5.053,0,0,0-8.64,3.578,5,5,0,0,0,5.062,5.062,5.17,5.17,0,0,0,2.112-.438A5.3,5.3,0,0,0,48.776,324.88Zm-3.825-4.605h6.356l-2.531,2.531H44.95Z",
    transform: "translate(-37.338 -313.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M182.41,313.918v2.551H174.8l-2.531-2.551Zm-7.612,6.356h7.612v2.531H172.266v-2.531Zm0,6.318h7.612v2.55H172.266v-.21Z",
    transform: "translate(-156.053 -313.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M298.018,313.757v15.171l-12.61-11.34v-3.831l10.088,9.084v-9.084Z",
    transform: "translate(-256.654 -313.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.112,313.918v9.23l-2.531,2.55v-11.78Z",
    transform: "translate(-519.786 -313.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.151,318.353a4.371,4.371,0,0,0-1.294-3.121,4.379,4.379,0,0,0-3.14-1.313h-8.24v12.93l2.532-2.55v-1.492h5.709a2.1,2.1,0,0,1,.762.152,1.85,1.85,0,0,1,.589.419,1.907,1.907,0,0,1,0,2.664,1.578,1.578,0,0,1-.628.418,1.876,1.876,0,0,1-.723.133h-5.709v2.55h5.709a4.291,4.291,0,0,0,1.712-.343,4.405,4.405,0,0,0,1.428-.97,4.37,4.37,0,0,0,1.294-3.121,4.226,4.226,0,0,0-1.332-3.178A4.283,4.283,0,0,0,456.151,318.353Zm-2.683.742a1.88,1.88,0,0,1-.4.609,1.58,1.58,0,0,1-.628.419,1.6,1.6,0,0,1-.723.152h-5.709v-3.806h5.709a1.877,1.877,0,0,1,.723.133,1.586,1.586,0,0,1,.628.418,1.972,1.972,0,0,1,.552,1.332A1.914,1.914,0,0,1,453.469,319.095Z",
    transform: "translate(-399.703 -313.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M588.723,427.591v2.55H578.581l2.531-2.55Z",
    transform: "translate(-519.817 -414.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.7,317.134v5.672a3.807,3.807,0,0,1-7.613,0v-8.888h-2.53v8.888a6.237,6.237,0,0,0,1.846,4.491,6.106,6.106,0,0,0,4.472,1.846h.039a6.106,6.106,0,0,0,4.472-1.846,6.237,6.237,0,0,0,1.846-4.491v-5.672Z",
    transform: "translate(-597.33 -313.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup192);
export default __webpack_public_path__ + "static/media/Group192.85a72774510b457733ceaa30376551fe.svg";
export { ForwardRef as ReactComponent };